import { useEffect, useState } from "react";
import { subscribePending } from "../lib/firestore-ops";

/**
 * Subscribes to the global pending-writes counter maintained by
 * firestore-ops. Resolves to true while at least one write is in flight
 * (queued or awaiting server ack), false when fully synced.
 */
export function usePendingWrites(): boolean {
  const [pending, setPending] = useState(false);
  useEffect(() => subscribePending(setPending), []);
  return pending;
}
